var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("營運資料中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("訂單資料查詢與匯出")])], 1)], 1)])]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('h4', [_vm._v("訂單資料查詢與匯出")]), _c('div', {
    staticClass: "row mx-0 justify-content-between mb-2 mt-3"
  }, [_c('div', [_c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-filter",
      modifiers: {
        "collapse-filter": true
      }
    }],
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-info"
    }
  }, [_c('span', {
    staticClass: "mdi mdi-filter"
  }), _vm._v("篩選條件 ")])], 1), _c('div', [_c('b-dropdown', {
    staticClass: "mr-2",
    attrs: {
      "text": "匯出",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    on: {
      "click": _vm.listExport
    }
  }, [_vm._v("清單匯出")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.detailExport
    }
  }, [_vm._v("明細匯出")])], 1)], 1)]), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-filter"
    }
  }, [_c('div', {
    staticClass: "border p-2 small"
  }, [_c('b-form', [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [_c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "通路名稱",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2 || _vm.showLoading
    },
    model: {
      value: _vm.query.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "merchant_id", $$v);
      },
      expression: "query.merchant_id"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "下單時間",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('DateSearchPicker', {
    staticClass: "mr-md-2 mr-0",
    attrs: {
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    on: {
      "input": _vm.handleDateChange
    },
    model: {
      value: _vm.orderDateBetween,
      callback: function callback($$v) {
        _vm.orderDateBetween = $$v;
      },
      expression: "orderDateBetween"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "單筆訂單金額",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-input', {
    staticClass: "mr-2",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": "最低金額",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.total_min,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "total_min", _vm._n($$v));
      },
      expression: "query.total_min"
    }
  }), _c('span', {
    staticClass: "mx-1"
  }, [_vm._v("～")]), _c('b-form-input', {
    staticClass: "ml-2",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "placeholder": "最高金額",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.total_max,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "total_max", _vm._n($$v));
      },
      expression: "query.total_max"
    }
  }), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("元")])], 1)]), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "商品標題/規格名稱",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋 商品標題/規格名稱",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.item_name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "item_name", $$v);
      },
      expression: "query.item_name"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "商品規格代碼/序號",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋 訂單明細編號/規格代碼/規格序號",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.item_code,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "item_code", $$v);
      },
      expression: "query.item_code"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "是否有使用點數",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.triStateOptions,
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.has_used_reward_points,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "has_used_reward_points", $$v);
      },
      expression: "query.has_used_reward_points"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "是否入點",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.pointsEntryOptions,
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.points_entry,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "points_entry", $$v);
      },
      expression: "query.points_entry"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "是否有會員",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-select', {
    staticClass: "mr-3",
    attrs: {
      "options": _vm.triStateOptions,
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.has_customer,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "has_customer", $$v);
      },
      expression: "query.has_customer"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "訂單狀態",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "完全比對",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "出貨狀態",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "完全比對",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.delivery_status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "delivery_status", $$v);
      },
      expression: "query.delivery_status"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "付款狀態",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "完全比對",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.payment_status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "payment_status", $$v);
      },
      expression: "query.payment_status"
    }
  })], 1), _c('b-form-group', {
    staticClass: "align-items-center",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "退貨狀態",
      "label-align": "left",
      "label-class": "pt-0 pb-0 d-flex align-items-center",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "完全比對",
      "size": "sm",
      "disabled": _vm.showLoading
    },
    model: {
      value: _vm.query.return_status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "return_status", $$v);
      },
      expression: "query.return_status"
    }
  })], 1)], 1), _c('div', {
    staticClass: "flex-column"
  }, [_c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置搜尋條件")]), _c('b-button', {
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.orders,
      "fields": _vm.dynamicFields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(order_number)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'OrderDetail',
              params: {
                order_id: data.item.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.order_number) + " ")])];
      }
    }, {
      key: "cell(memo)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex flex-column align-items-center"
        }, [data.item.memo ? _c('span', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-memo-view",
            modifiers: {
              "modal-memo-view": true
            }
          }],
          staticClass: "mdi mdi-tag-text-outline mr-1",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "1rem"
          },
          attrs: {
            "id": "popover-memo-".concat(data.item.id)
          },
          on: {
            "click": function click($event) {
              _vm.modalTitle = '消費備註', _vm.modalContent = data.item.memo;
            }
          }
        }) : _vm._e(), data.item.memo ? _c('b-popover', {
          attrs: {
            "target": "popover-memo-".concat(data.item.id),
            "triggers": "hover focus"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("點擊，觀看『消費備註』")])]) : _vm._e(), data.item.processed_memo ? _c('span', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-memo-view",
            modifiers: {
              "modal-memo-view": true
            }
          }],
          staticClass: "mdi mdi-coin",
          staticStyle: {
            "cursor": "pointer",
            "font-size": "1rem"
          },
          attrs: {
            "id": "popover-points-".concat(data.item.id)
          },
          on: {
            "click": function click($event) {
              _vm.modalTitle = '入點說明', _vm.modalContent = data.item.processed_memo;
            }
          }
        }) : _vm._e(), data.item.processed_memo ? _c('b-popover', {
          attrs: {
            "target": "popover-points-".concat(data.item.id),
            "triggers": "hover focus"
          }
        }, [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("點擊，觀看『入點說明』")])]) : _vm._e()], 1)];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: 'OrderDetail',
              params: {
                order_id: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye mr-1"
        }), _vm._v("查看 ")])];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  }), _c('b-modal', {
    attrs: {
      "id": "modal-memo-view",
      "title": _vm.modalTitle
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          staticClass: "float-right",
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 關閉 ")])];
      }
    }])
  }, [_c('div', {
    staticClass: "p-3",
    staticStyle: {
      "white-space": "pre-wrap",
      "max-height": "400px",
      "overflow-y": "auto"
    }
  }, [_vm._v(_vm._s(_vm.modalContent))])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }